/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import * as _ from 'lodash';

import template from './creative-copy-in-bulk-modal.component.html';
import {LocalNetworkInfo} from '../../components/session/local-network-info';
import {Uuid} from '../../components/util/uuid';
import {AdnModalLoadingService} from '../common/util/adn-modal-loading.service';
import {bulkApiErrorsFromResponse} from '../common/controller/bulk-action-errors';
import {deferMarkForCheck} from '../common/util/defer-mark-for-check';

@Component({
  standalone: false,
  selector: 'adn-creative-copy-in-bulk-modal',
  template
})
export class CreativeCopyInBulkModalComponent implements OnInit {
  list: any;
  Creative: any;
  onComplete: (updatedCreatives?: any, bulkSelection?: any) => void;

  attach = 'LINE_ITEM';
  hasCreativeSet = false;
  noGoodMessage: string;
  adv: any;
  form: any = {};
  lineItem: any;
  creativeSet: any;

  constructor(
    public bsModalRef: BsModalRef,
    @Inject(AdnModalLoadingService) private readonly adnModalLoading: any,
    private readonly cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.hasCreativeSet = LocalNetworkInfo.obtain().getInfo('creativeSetCount') > 0;

    const advs = _.uniqBy(_.filter(_.map(this.list.bulkSelection, (val: any) => {
      return _.get(val, ['advertiser']);
    }), (f: any) => {
      return _.get(f, ['id']);
    }), 'id');

    if (advs.length > 1) {
      this.noGoodMessage = 'The creatives you selected belong to more than one advertiser. You cannot copy these creatives in bulk.';
    } else if (advs.length === 1) {
      this.adv = advs[0];
    } else if (Object.keys(this.list.bulkSelection).length === 0) {
      this.noGoodMessage = 'No creatives have been selected to copy.';
    }
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }

  copyInBulk(): void {
    this.form.apiErrors = [];
    this.form.bulkError = false;
    const copyPromises: any[] = [];
    _.forEach(this.list.bulkSelection, (creative: any) => {
      if (this.attach === 'LINE_ITEM') {
        copyPromises.push(this.Creative.copyCreative(creative, this.lineItem, Uuid.generate()));
      } else {
        copyPromises.push(this.Creative.copyCreative(creative, null, Uuid.generate(), null, this.creativeSet));
      }
    });
    Promise.all(copyPromises).then((updatedCreatives: any) => {
      this.list.disabled = false;
      this.adnModalLoading.removeModalLoading();
      this.onComplete?.(updatedCreatives, this.list.bulkSelection);
      this.bsModalRef.hide();
    }, (response: any) => {
      this.adnModalLoading.removeModalLoading();
      deferMarkForCheck(this.cdr, () => {
        this.list.disabled = false;
        this.form.apiErrors = bulkApiErrorsFromResponse(response);
        this.form.bulkError = true;
      });
    });
  }
}
